import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
    selector: 'dk-input',
    templateUrl: './dk-input.component.html',
    styleUrl: './dk-input.component.scss',
    standalone: false
})
export class DkInputComponent implements OnInit {
  /* -------------------------------------------------------------------------- */
  /*                                    label                                   */
  /* -------------------------------------------------------------------------- */
  @Input() label: string;
  @Input() labelDescription: string;

  /* -------------------------------------------------------------------------- */
  /*                               bootstrap grid                               */
  /* -------------------------------------------------------------------------- */

  @Input() col = '12'; // mobile   col-12 col-sm-12 col-md-6 col-lg-4
  @Input() sm = '12'; // small
  @Input() md = '12'; // medium
  @Input() lg = '12'; // medium
  @Input() xl = '12'; // extra large

  @Input() has_my3 = false; // my-3
  @Input() has_mb3 = false; // mb-3

  @Input() toggleMask = true;
  @Input() feedback = false;

  /* -------------------------------------------------------------------------- */
  /*                                    form                                    */
  /* -------------------------------------------------------------------------- */

  @Input() formGroup: FormGroup;
  @Input() controlName: string; // formCountrolName
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() autocomplete: string;
  @Input() disabled = false;
  @Input() autoFocus = false;
  

  /* -------------------------------------------------------------------------- */
  /*                                   ngModel                                  */
  /* -------------------------------------------------------------------------- */
  value: any;

  /* -------------------------------------------------------------------------- */
  /*                                 validation                                 */
  /* -------------------------------------------------------------------------- */
  @Input() minlength: any;
  @Input() maxlength: any;
  @Input() pattern: any; // RegEx
  @Input() min: any;
  @Input() max: any;
  @Input() mask: string;

  @Input() minDecimalDigits = '0';
  @Input() maxDecimalDigits = '0';
  @Input() separateNumbers = true;

  /* -------------------------------------------------------------------------- */
  /*                             validation messages                            */
  /* -------------------------------------------------------------------------- */

  @Input() patternRequired = false;
  @Input() patternMessage = '';
  isPassword = false;

  @ViewChild('input') inputRef: ElementRef;

  @Output() onChange = new EventEmitter();

  /* -------------------------------------------------------------------------- */
  /*                                 constructor                                */
  /* -------------------------------------------------------------------------- */
  constructor(
    private cdref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['disabled'] && this.control) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-' + this.col);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-sm-' + this.sm);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-md-' + this.md);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-lg-' + this.lg);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-xl-' + this.xl);
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  ngAfterViewInit() {
    if (this.autoFocus) this.inputRef['nativeElement'].focus();
  }

  get control(): AbstractControl {
    if (this.formGroup && this.controlName) {
      return this.formGroup?.controls[this.controlName];
    }
    return null;
  }

  // to set the star
  get required(): boolean {
    if (!this.control || !this.control?.validator) {
      return false;
    }

    const validator = this.control.validator({} as AbstractControl);
    return validator?.['required'];
  }

  get controlError() {
    if (this.control?.invalid && this.control?.touched) {
      if (this.patternRequired && this.patternMessage) {
        return this.patternMessage;
      } else if (this.control?.errors) {
        if (this.control.errors['required']) {
          return 'This field is required.';
        }
        if (this.control.errors['email']) {
          ('Email address is not correct.');
        }
        if (this.control.errors['minlength']) {
          return `Min length: ${this.control.errors['minlength'].requiredLength}`;
        }
      }
    }
    return null;
  }
}
